<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 0">
                <base-button slot="title" type="primary" class="dropdown-toggle">
                Document - {{ _.startCase(currentProfile).replace("B 2 B", "B2B") }}
                </base-button>
                <a
                v-for="profile in activeModules"
                :key="profile.id"
                @click.prevent="
                    setCurrentProfile(
                    _.pluralize(_.snakeCase(profile.name)),
                    profile.id
                    )
                "
                class="dropdown-item"
                href="#"
                >{{ profile.name }}</a
                >
            </base-dropdown>
            <base-dropdown v-else>
                <base-button slot="title" type="primary" class="dropdown-toggle">
                Document
                </base-button>
                <a class="dropdown-item" disabled
                >No active module/s under this feature</a
                >
            </base-dropdown>
        </base-header>

         <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card mb-3">
                        <div class="row no-gutters">
                            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                              <div class="card-body">
                                  <filter-bar @changeFilter="changeFilter" :key="statusKey"></filter-bar>
                              </div>
                            </div>

                            <div class="col-md-9">
                            <a-spin :spinning="spinning">
                              <div class="card-body">
                                  <add-on-charges-table :status="filterStatus" :key="formKey" :accessRights="accessRights"></add-on-charges-table>
                              </div>
                            </a-spin>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
  import HTTPRequest from '../../controllers/httpRequest.js'
  import AddOnChargesTable from '../Tables/AddOnChargeTable.vue'
  import FilterBar from './../FilterBar' 
  import { mapState, mapActions } from 'vuex'
  import secureStorage from '../../controllers/secureStorage';
  import moment from 'moment';

  export default {
      data: function(){
          return {
              spinning: true,
              formKey: 0,
              activeModules: [],
              accessRights: [],
              gradientType: "instore",
              buttonType: "success",
              statusKey:0,
              filterStatus: ''
          }
      },
      watch:{
        $route: async function (to, from) {
            await this.loadPage();
        }
      },
      mounted: async function() {
            this.loadPage()
      },
      computed: {
              ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
          },
          components: {
              AddOnChargesTable,
              FilterBar
          },
          methods: {
              ...mapActions(['updateCurrentProfile', 'updateParameters']),
              async loadPage(){
                    var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=AOC-001', null, null)
                    this.activeModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
                    console.log(categoryId);
                    console.log(this.activeModules);
                    if( this.activeModules.length > 0 ){
                        var profile = _.snakeCase(this.activeModules[0].name)
                        this.setCurrentProfile(_.pluralize(profile), this.activeModules[0].id);
                    } else {
                        this.setCurrentProfile(null, null);
                        this.formKey++
                    } 
                    this.gradientType = "instore"
                    this.buttonType = "success"
                    this.spinning = false
              },
              moment,
              async setCurrentProfile(profile, id) {
                this.profileId = id
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[id]
                }else {
                    this.accessRights = []
                }
                this.updateCurrentProfile(profile)
                this.statusKey++;
                this.formKey++;
              },
              changeFilter(statusFilter, searchFilter, searchText, document_date) {
                  this.spinning = true
                  this.filterStatus = statusFilter
                  if(statusFilter == "0"){
                      this.updateParameters("?" + searchFilter + "=" + searchText + "&from_date=" + this.moment(document_date[0]).format('YYYY-MM-DD') + "&to_date=" + this.moment(document_date[1]).format('YYYY-MM-DD'))
                  } else {
                      this.updateParameters("?" + searchFilter + "=" + searchText + "&status="+statusFilter + "&from_date=" + this.moment(document_date[0]).format('YYYY-MM-DD') + "&to_date=" + this.moment(document_date[1]).format('YYYY-MM-DD'))
                  }
                  this.spinning = false
              },
          }
      };
</script>

<style></style>